import cx from "classnames";
import React, { ReactNode, useContext, useEffect, useState } from "react";
import CallbackModal from "../../common/components/Modals/CallbackModal/CallbackModal";
import { IContactDetails } from "../../common/interfaces/IContactDetails";
import MobileNavMulticompare from "../../compare/components/MobileNavMulticompare/MobileNavMulticompare";
import { useAppFormUtils } from "../hooks/useAppFormUtils";
import { IPageInfo } from "../interfaces/IAppFormData";
import { AppFormControllerContext } from "../providers/AppFormProvider";
import { IViewContext, LoadExtent, ViewContext } from "../providers/ViewStateProvider";
import AFErrorDialog from "./AFErrorDialog";
import AFLoadingSpinner from "./AFLoadingSpinner";
import AFSecure from "./AFSecure";
import AFSidebar from "./AFSidebar";


interface ILayout {
    children: ReactNode;
    currentPage: IPageInfo;
};

const AFLayout: React.FC<ILayout> = ({ children, currentPage }: ILayout) => {
    const { viewState, hasError } = useContext<IViewContext>(ViewContext);
    const { selectors } = useContext(AppFormControllerContext);
    const { populateDataLayer } = useAppFormUtils();
    const [isOpenCallback, setIsOpenCallback] = useState(false);
    const [isSidebarVisibleMobile, setIsSidebarVisibleMobile] = useState(true);

    const mainApplicant = selectors.getApplicantList()[0];
    const contactDetails: IContactDetails = {
        name: mainApplicant.firstName,
        emailAddress: mainApplicant.email,
        phoneNumber: mainApplicant.phone,
        bestContactTime: mainApplicant.bestContactTime
    }

    const toggleSidebar = () => {
        setIsSidebarVisibleMobile(!isSidebarVisibleMobile);
    };

    useEffect(() => {
        populateDataLayer(selectors.getApplicationId(), selectors.getQuoteGroupId());
    }, []);

    return (
        <div className="panel-appform-body layout-form-page-container">
            {hasError() && <AFErrorDialog />}
            <MobileNavMulticompare />
            <CallbackModal
                source={"Appform"}
                groupId={selectors.getQuoteGroupId()}
                contactDetails={contactDetails}
                isOpen={isOpenCallback}
                onClose={() => setIsOpenCallback(false)}
            />
            <div className={cx("layout-limited-width-l")}>
                {viewState.loadingExtent == LoadExtent.Full ? (
                    <AFLoadingSpinner text="Preparing your application" />
                ) : (
                    <div className="grid-section">
                        <div className={cx("grid-4", "grid-5-l-sub",
                            {
                                "hide-mobile": isSidebarVisibleMobile
                            })}>
                            <AFSidebar currentPage={currentPage} />
                        </div>
                        <div className="grid-6 grid-7-l-sub">
                            <div className="hide-non-mobile gap-l space-pre-l space-l">
                                {/*the "jump to section" button will go here for mobile when the sidebar has navigation functionality*/}
                                <AFSecure />
                            </div>
                            {viewState.loadingExtent == LoadExtent.Panel ? (
                                <AFLoadingSpinner text="Loading" />
                            ) : (<React.Fragment>{children}</React.Fragment>)}
                        </div>
                        <div className="grid-2 grid-full-l-sub">
                            <div className="panel-green-lt panel-right-sidebar">
                                <AFSecure />
                                <div>
                                    <h3>Need help?</h3>
                                    <p><a href="#" onClick={() => setIsOpenCallback(true)}>Schedule a phone call</a> with our Wellington-based team or call <a href="tel:+64800800400">0800 800 400</a>.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default AFLayout;
